import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import SingleFile from "../custom/SingleFile/SingleFile";
import { ComponentContext } from "../../contexts";
import singleFileStore from "../../stores/singleFileStore";

function StandaloneSingleFile(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compStore=new singleFileStore(props);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  return (
    <div>
      <ComponentContext.Provider value={compStore}>
        <SingleFile />
      </ComponentContext.Provider>
    </div>
  )
};

StandaloneSingleFile.defaultProps = {};

StandaloneSingleFile.propTypes = {}

export default observer(StandaloneSingleFile);
